"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deriveRoute = deriveRoute;
exports.buildDerivedRouteRequest = buildDerivedRouteRequest;

var _compliance = require("./compliance.helpers");

/* globals ALKMaps */
var debug = require("debug")("compliance:deriveroute");


/**
   * @param {array} latLonArray latlong ie. [ [0,0], [1,1] ]
   * @param {object} routingProfile profile
   * @param {int} tripId id
   * @param {string} tripType 0 for planned, 1 for actual
   * @param {object} deps hash of dependencies
   * @returns {Promise} deferred value
**/
function deriveRoute(latLonArray, routingProfile, tripId, tripType, deps) {
  var $q = deps.$q,
      cacheService = deps.cacheService,
      ComplianceRoutingProfileService = deps.ComplianceRoutingProfileService,
      UserProvider = deps.UserProvider,
      mapUtilities = deps.mapUtilities;


  var deferred = $q.defer();
  if (!latLonArray || latLonArray.length === 0) {
    deferred.resolve([]);
    return deferred.promise;
  }

  var profileName = routingProfile ? routingProfile.name : "--";
  var tripCacheKey = tripId + "_" + profileName + "_" + (tripType === 0 ? "planned" : "actual");
  //Fetch from cache if exists
  var cachedRoutePoints = cacheService.getCachedRoutePoints(tripCacheKey, routingProfile);
  if (cachedRoutePoints) {
    deferred.resolve(cachedRoutePoints);
    return deferred.promise;
  }
  var offRouteMiles = 0.03; // Always use 0.03 to account for small variations in Data Versions
  //Show the aligned route
  var request = ComplianceRoutingProfileService.getDerivedRouteRequest(latLonArray, routingProfile, offRouteMiles);
  debug("getDerivedRouteRequest() -> request:", request);

  ALKMaps.Services.postDerivedRoutePath({
    request: request,
    dataset: UserProvider.getUser().dataVersion,
    success: function success(results) {
      if (!results) {
        deferred.resolve([]);
        return;
      }
      var mercPoints = (0, _compliance.getMercPoints)(results, mapUtilities);
      //Cache using tripId and routingProfile.routingProfileId
      cacheService.setCachedRoutePoints(tripCacheKey, routingProfile, mercPoints);
      deferred.resolve(mercPoints);
    },
    failure: function failure(error) {
      debug("ALKMaps.Services.postDerivedRoutePath() >> error:", error, latLonArray);
      deferred.reject(error);
    }
  });

  return deferred.promise;
}

function buildDerivedRouteRequest(_ref) {
  var region = _ref.region,
      routingProfile = _ref.routingProfile,
      latLonArray = _ref.latLonArray,
      offRouteMiles = _ref.offRouteMiles,
      weight = _ref.weight,
      isMetric = _ref.isMetric;

  // https://developer.dev.trimblemaps.com/restful-apis/routing/post-route-reports/
  // refer to Libraries\ALK.Common.Model\RoutingProfiles\RoutingProfile.cs
  var request = {
    "RoutePings": (0, _compliance.getRoutePings)(latLonArray),
    "OffRouteMiles": offRouteMiles,
    "HighwayOnly": routingProfile.highwayOnly || false,
    "ReportType": null,
    "Region": region,
    "RoutingOptions": {
      "VehicleType": _compliance.routingProfileProps.vehicleTypes[routingProfile.vehicleType],
      "RoutingType": _compliance.routingProfileProps.routingTypes[routingProfile.routingType],
      "HighwayOnly": routingProfile.highwayOnly || false,
      "UseAvoidsAndFavors": routingProfile.useAvoidFavors,
      "ClassOverrides": routingProfile.classOverrides,
      "DistanceUnits": _compliance.routingProfileProps.distanceUnits[routingProfile.distanceUnits],
      "TollDiscourage": routingProfile.tollDiscouraged || false,
      "BordersOpen": routingProfile.bordersOpen,
      "OverrideRestrict": routingProfile.overrideRestrictions,
      "HazMatType": _compliance.routingProfileProps.hazmatTypes[routingProfile.hazmatType],
      "RouteOptimization": null,
      "TruckCfg": {
        "Weight": weight,
        "Axles": routingProfile.numAxles < 2 ? null : routingProfile.numAxles,
        "Units": _compliance.routingProfileProps.unitTypes[routingProfile.unitsOfMeasure],
        "LCV": routingProfile.lcv,
        "Width": routingProfile.maxWidth ? routingProfile.maxWidth + (isMetric ? "" : "\"") : null,
        "Height": routingProfile.maxHeight ? routingProfile.maxHeight + (isMetric ? "" : "\"") : null,
        "Length": routingProfile.totalLength ? routingProfile.totalLength + (isMetric ? "" : "\"") : null
      },
      "HubRouting": routingProfile.hubRouting,
      "AFSetIDs": null,
      "ElevLimit": routingProfile.elevationLimit,
      "FerryDiscourage": routingProfile.isFerryDiscouraged,
      "GovernorSpeedLimit": routingProfile.governorSpeedLimit,
      "sideOfStreetAdherence": routingProfile.sideOfStreetAdherence,
      "useSites": routingProfile.useSites,
      "useTraffic": routingProfile.useTraffic
    }
  };

  // This is needed so the PCM derivedRoute/routePath service call doesn't return 400
  request.RoutingOptions = (0, _compliance.removeEmptyProp)(request.RoutingOptions);
  return request;
}


// WEBPACK FOOTER //
// ./app/compliance/deriveRoute.js